import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import userImage from '../assets/img/128x128.jpg';
import moment from 'moment';
import * as AuthActions from '../store/actions/authActions';
import api from '../utils/api';
import {NotificationManager} from 'react-notifications';
import MiniLoader from "./MiniLoader";

/* global $ */
class Users extends Component {
    constructor(props){
        super(props);

        this.state = {
            search: '',
            userToDelete: null,
            deleteEmail: '',
            canDelete: false
        }
    }

    renderImg = (row) => (
        <img
            className="chat-avatar"
            src={api.makeFileURL(row.Profile.image, this.props.user.id) || userImage}
            alt={row.name}
        />
    );

    updateDeleteEmail = (v) => {
        let {canDelete, userToDelete} = this.state;
        if(v === userToDelete.email){
            canDelete = true;
        }
        this.setState({deleteEmail: v, canDelete});
    }

    confirmDelete = () => {
        this.props.deleteUser(this.state.userToDelete.id, this.props.user.id);
        this.setState({
            userToDelete: null,
            deleteEmail: '',
            canDelete: false
        });
    }

    componentDidMount(){
        if(this.props.match.params.search){
            if(this.props.match.params.search === 'all'){
                this.props.getUsers(this.props.user.id, 0);
                
            }else{
                let where = {};

                let terms = this.props.match.params.search.split(' ');
                terms.map(t => {
                    if(t.indexOf('=') > -1){
                        let splitted = t.split('=');
                        where[splitted[0]] = {like: splitted[1]};
                    }else{
                        where['email'] = {like: t}
                    }
                })

                this.props.findUsers(where, this.props.user.id, 0);
            }
        }
    }

    displayDeleteConfirmation = () => {
        return (
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                        <h4 className="modal-title" id="myModalLabel">Delete User</h4>
                    </div>
                    <div className="modal-body no-padding">
                        <div className="modal-body">
                            {this.state.userToDelete ?
                                <div>
                                    <p>Are you sure you want to delete {this.state.userToDelete.email} from the app?</p>
                                    <h2 className="text-danger">This action is irreversable!</h2>
                                    <p>Deleting this user will remove all of their content and the information deleted can not be recovered.</p>
                                    <p>To verify, please type the users email below.</p>
                                    <input className="form-control" placeholder="Enter users email address" type="text" value={this.state.deleteEmail} onChange={e => this.updateDeleteEmail(e.target.value)} />
                                </div>
                                : null}


                        </div>

                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" data-dismiss="modal" onClick={e => this.props.resetModalDisplay(0)}>Close</button>
                        {this.state.canDelete ?
                            <button type="button" className="btn btn-success" onClick={e => this.confirmDelete()}>Delete</button>
                            : null
                        }
                    </div>
                </div>
            </div>
        )
    }

    displayResults = () => {
        return (
            <div>
                {this.props.deleteCounts && this.props.deleteFields ?
                    Object.keys(this.props.deleteCounts).map((d, i) => {
                        if (i === 0) {
                            return (
                                <div>
                                    <div className={"resultRowHeader"}><i className={"zmdi zmdi-account-circle"} /> <span>User Data</span></div>
                                    <div className={"resultRow"}>
                                        <span className={"resultTitle"}>{this.props.deleteFields[d]}</span>
                                        <span className={"resultValue"}>{this.props.deleteCounts[d]}</span>
                                    </div>
                                </div>
                            )
                        } else if (i === 2) {
                            return (
                                <div>
                                    <div className={"resultRowHeader"}><i className={"zmdi zmdi-chart-donut"} /> <span>Course Progress Data</span></div>
                                    <div className={"resultRow"}>
                                        <span className={"resultTitle"}>{this.props.deleteFields[d]}</span>
                                        <span className={"resultValue"}>{this.props.deleteCounts[d]}</span>
                                    </div>
                                </div>
                            )
                        } else if (i === 8) {
                            return (
                                <div>
                                    <div className={"resultRowHeader"}><i className={"zmdi zmdi-comment-outline"} /> <span>Social Data</span></div>
                                    <div className={"resultRow"}>
                                        <span className={"resultTitle"}>{this.props.deleteFields[d]}</span>
                                        <span className={"resultValue"}>{this.props.deleteCounts[d]}</span>
                                    </div>
                                </div>
                            )
                        } else if (i === 11) {
                            return (
                                <div>
                                    <div className={"resultRowHeader"}><i className={"zmdi zmdi-time"} /> <span>Uncategorized Data</span></div>
                                    <div className={"resultRow"}>
                                        <span className={"resultTitle"}>{this.props.deleteFields[d]}</span>
                                        <span className={"resultValue"}>{this.props.deleteCounts[d]}</span>
                                    </div>
                                </div>
                            )
                        } else {
                            return (
                                <div className={"resultRow"}>
                                    <span className={"resultTitle"}>{this.props.deleteFields[d]}</span>
                                    <span className={"resultValue"}>{this.props.deleteCounts[d]}</span>
                                </div>
                            )
                        }
                })
                : null}
            </div>
        )
    }

    displayDeleteResults = () => {
        return (
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                        <h4 className="modal-title" id="myModalLabel">Deletion Results</h4>
                    </div>
                    <div className="modal-body no-padding">
                        <div className="modal-body">
                            {this.props.modalLoading ?
                                <MiniLoader />
                                :
                                this.displayResults()

                            }
                        </div>

                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" data-dismiss="modal" onClick={e => this.props.resetModalDisplay(0)}>Close</button>
                    </div>
                </div>
            </div>
        )
    }

    componentDidUpdate(props){

    }

    render(){
        let {allUsers} = this.props;
        if(this.props.user.user.role !== 'admin'){
            return null;
        }

        return (
            <div id="content-container" className="content-wrapper">
                <section className="content">
                    <div className="panel customPanel">
                    <div className="panel-body no-padding darkest-panel" style={{ background: "#181818 !important" }}>

                    <div className="sp-20">
                        <div className="clearfix">
                            <div className="RFH">
                            
                                <div style={{display: 'block', width: '100%'}}>
                                    
                                    <div className="font-24 text-white sm-bottom30">
                                        <div className="pull-left">
                                        <span className="pull-left">Users  &nbsp;</span> &nbsp;
                                        <button onClick={e => {
                                            e.preventDefault();
                                            this.props.sendAllToken(this.props.user.id);

                                        }} className="btn btn-primary" style={{display: 'inline-block'}}>Send All Verification Emails</button> &nbsp;

                                        {/*
                                        <button onClick={e => {
                                            e.preventDefault();

                                        }} className="btn btn-info" style={{display: 'inline-block'}}>Log All Students Off</button> &nbsp;

                                        <button onClick={e => {
                                            e.preventDefault();

                                        }} className="btn btn-info" style={{display: 'inline-block'}}>Log All Instructors Off</button> &nbsp;
                                    */}
                                        </div>
                                    <div className="pull-right" style={{width: 600 + 'px'}}>
                                    <form onSubmit={e => {
                                        e.preventDefault();
                                        this.props.history.push('/users/' + this.state.search);
                                        if(this.state.search === 'all'){
                                            this.props.getUsers(this.props.user.id, 0);
                                            
                                        }else{
                                            let where = {};
                            
                                            let terms = this.state.search.split(' ');
                                            terms.map(t => {
                                                if(t.indexOf('=') > -1){
                                                    let splitted = t.split('=');
                                                    where[splitted[0]] = {like: splitted[1]};
                                                }else{
                                                    where['email'] = {like: t}
                                                }
                                            })
                            
                                            this.props.findUsers(where, this.props.user.id, 0);
                                        }
                                    }}>
                                        <input type="text" className="form-control pull-right" placeholder="Search" style={{display: 'inline-block', width: '350px'}} value={this.state.search} onChange={e => this.setState({search: e.target.value})} /> 
                                        <button  style={{display: 'inline-block', position: 'absolute', right: '20px', fontSize: '24px'}} className="btn btn-transparent"><i className="zmdi zmdi-search" /></button>
                                    </form>
                                    
                                       
                                        
                                    </div>
                                    </div>
                                </div>
                                <div>
                                    
                                </div>

                            </div>

                        </div>
                        
                        <table className="table" style={{background: "#181818"}}>
                            <tbody>
                            <tr>
                                <th style={{width: "90px"}}></th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Course</th>
                                <th>Verification</th>
                                <th>Role</th>
                                <th>Action</th>

                                <th style={{width: "190px"}}><i className="zmdi zmdi-calendar font-24"></i></th>
                            </tr>
                            {allUsers.length > 0 ?
                                    allUsers.map(f => {
                                        if(f.Profile){
                                        return (
                                            <tr>
                                                <td className="text-center">
                                                    {f.Profile.image ? this.renderImg(f) :  <img className="chat-avatar" src={userImage} alt={f.name} />}
                                                </td>
                                                <td>{f.Profile.name ? f.Profile.name + ' ' + f.Profile.lname : 'No Name'}</td>
                                                <td><a href={`mailto:${f.email}`}>{f.email}</a></td>
                                                <td>{f.Profile.CourseUser ? 
                                                f.Profile.CourseUser.filter(cu => cu.Course).map((cu, i) => {
                                                    if(cu.Course){
                                                        return i === f.Profile.CourseUser.length - 1 ? cu.Course.name : cu.Course.name + ', ';
                                                    }
                                                    
                                                })
                                                : null}</td>
                                                <td>{!f.emailVerified ? 
                                                    <div className="email-verify-container">
                                                        <button onClick={e => {
                                                            e.preventDefault();
                                                            this.props.sendToken(f, this.props.user.id);

                                                        }} className="btn btn-primary">Send Verification Email</button>
                                                        {f.verificationToken ? 'https://portal.99point9.ca/verify/' + f.verificationToken : ''}
                                                    </div>
                                                    
                                            
                                                : <p className="text-success">Verified</p>}</td>
                                                <td>{f.role}</td>
                                                <td><button className="btn btn-outline btn-primary" href="#deleteUserModal" onClick={e => {
                                                    this.setState({userToDelete: f, canDelete: false, deleteEmail: ''});
                                                }} data-toggle="modal">Delete</button></td>
                                                <td style={{verticalAlign: "middle"}}>{moment(f.Profile.created).format('YYYY-MM-DD')}</td>
                                            </tr>      
                                        )
                                        }
                                    })
                                    :
                                    null
                                }
                            </tbody>
                        </table>
                        
                    </div>
                        </div>
                        </div>
                        <div className="text-center">
                        <button className="btn btn-primary" onClick={e => {
                            if(this.state.search === 'all'){
                                this.props.getUsers(this.props.user.id, allUsers.length);
                                
                            }else{
                                let where = {};
                
                                let terms = this.state.search.split(' ');
                                terms.map(t => {
                                    if(t.indexOf('=') > -1){
                                        let splitted = t.split('=');
                                        where[splitted[0]] = {like: splitted[1]};
                                    }else{
                                        where['email'] = {like: t}
                                    }
                                })
                
                                this.props.findUsers(where, this.props.user.id, allUsers.length);
                            }
                        }}>Load More</button>
                        </div>

                    
                </section>
                <div className="modal fade in" id="deleteUserModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                    {this.props.modalDisplay !== 1 ?
                        this.displayDeleteConfirmation()
                    :
                        this.displayDeleteResults()
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.auth
    }
}

const mapDispatchToProps = (dispatch) => ({
    getUsers: (token, skip) => {
        dispatch(AuthActions.getUsers(token, skip));
    },
    findUsers: (where, token, skip) => {
        // console.log("Finding students", where, token, skip);
        dispatch(AuthActions.findUsers(where, token, skip));
    },
    sendToken: (user, token) => {
        dispatch(AuthActions.sendToken(user, token));
    },
    sendAllToken: (token) => {
        dispatch(AuthActions.sendAllTokens(token));
    },
    deleteUser: (id, token) => {
        dispatch(AuthActions.deleteUser(id, token));
    },
    resetModalDisplay: (mode) => {
        dispatch(AuthActions.resetModalDisplay(mode));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps)(withRouter(Users));


// WEBPACK FOOTER //
// ./src/components/Users.js